export enum RiderEntryPaymentStatus {
  PENDING_PAYMENT = 'pending_payment',
  CAPTURED = 'captured',
  VOIDED = 'voided',
  AUTHORIZED = 'authorized',
  // SCRATCHED = 'scratched',
  CAPTURE_FAILED = 'capture_failed',
  MANUALLY_MARK_AS_PAID = 'manually_mark_as_paid', // done from utilies tool by admin
  PAID_BY_OTHER = 'paid_by_other'
}
export enum PaymentProcessTypeEnum {
  ACCESS_IEA = "access_iea",
  SHOW_HOST = "show_host"
}